import { createAction } from '@ngrx/store';
import { ApiError } from '../../../../common/models/api-response.interface';
import { PartnerDetail } from '../../../../common/models/search.interface';
import {
    createFeatureReducer,
    FeatureActionReducer,
    PayloadAction
} from '../../store/store.utils';
import { initialSharedState, SharedState } from './shared.state';
import {
    PreferredPaymentModePayload,
    ReprocessPaymentResponsePayload
} from '../../../../common/models/payments.interface';

export const clearState = createAction('[App] Clear State');

export abstract class SharedActionReducer extends FeatureActionReducer<SharedState> {
    protected constructor(name: string) {
        super('Shared', name);
    }
}

export class GetPartnerDataRequest extends SharedActionReducer {
    constructor() {
        super('Get Partner/Retailer picklist data request');
    }

    reduce(state: SharedState): SharedState {
        return {
            ...state,
            ui: {
                ...state.ui,
                partnerPicklist: {
                    loading: true
                }
            }
        };
    }
}

export class GetPartnerDataRequestSuccess
    extends SharedActionReducer
    implements PayloadAction<PartnerDetail[]>
{
    constructor(public readonly payload: PartnerDetail[]) {
        super('Get Partner/Retailer picklist data successful');
    }

    reduce(state: SharedState): SharedState {
        return {
            ...state,
            ui: {
                ...state.ui,
                partnerPicklist: {
                    ...state.ui?.partnerPicklist,
                    loading: false
                }
            },
            data: {
                ...state.data,
                partnerPicklist: {
                    ...state.data?.partnerPicklist,
                    partnerData: this.payload
                }
            }
        };
    }
}

export class GetPartnerDataRequestFailure
    extends SharedActionReducer
    implements PayloadAction<ApiError>
{
    constructor(public readonly payload: ApiError) {
        super('Get Partner/Retailer picklist data failed');
    }

    reduce(state: SharedState): SharedState {
        return {
            ...state,
            ui: {
                ...state.ui,
                partnerPicklist: {
                    ...state.ui?.partnerPicklist,
                    loading: false
                }
            }
        };
    }
}

export class GetPreferredPaymentInfoRequest
    extends SharedActionReducer
    implements PayloadAction<string>
{
    constructor(public readonly payload: string) {
        super('Get Preferred Payment Info Request');
    }

    reduce(state: SharedState): SharedState {
        return {
            ...state,
            ui: {
                ...state.ui,
                preferredPaymentInfo: {
                    loading: true
                }
            }
        };
    }
}

export class GetPreferredPaymentInfoRequestSuccess
    extends SharedActionReducer
    implements PayloadAction<PreferredPaymentModePayload>
{
    constructor(public readonly payload: PreferredPaymentModePayload) {
        super('Get Preferred Payment Info Request Successful');
    }

    reduce(state: SharedState): SharedState {
        return {
            ...state,
            ui: {
                ...state.ui,
                preferredPaymentInfo: {
                    ...state.ui?.preferredPaymentInfo,
                    loading: false
                }
            },
            data: {
                ...state.data,
                preferredPaymentInfo: this.payload
            }
        };
    }
}

export class GetPreferredPaymentInfoRequestFailure
    extends SharedActionReducer
    implements PayloadAction<ApiError>
{
    constructor(public readonly payload: ApiError) {
        super('Get Preferred Payment Info Request Failed');
    }

    reduce(state: SharedState): SharedState {
        return {
            ...state,
            ui: {
                ...state.ui,
                preferredPaymentInfo: {
                    ...state.ui?.preferredPaymentInfo,
                    loading: false
                }
            }
        };
    }
}

export class SetPreferredPaymentInfoRequest
    extends SharedActionReducer
    implements PayloadAction<PreferredPaymentModePayload>
{
    constructor(public readonly payload: PreferredPaymentModePayload) {
        super('Set Preferred Payment Info Request');
    }

    reduce(state: SharedState): SharedState {
        return {
            ...state,
            ui: {
                ...state.ui,
                preferredPaymentInfo: {
                    loading: true
                }
            }
        };
    }
}

export class SetPreferredPaymentInfoRequestSuccess
    extends SharedActionReducer
    implements PayloadAction<ReprocessPaymentResponsePayload>
{
    constructor(public readonly payload: ReprocessPaymentResponsePayload) {
        super('Set Preferred Payment Info Request Successful');
    }

    reduce(state: SharedState): SharedState {
        return {
            ...state,
            ui: {
                ...state.ui,
                preferredPaymentInfo: {
                    loading: false
                }
            }
        };
    }
}

export class SetPreferredPaymentInfoRequestFailure
    extends SharedActionReducer
    implements PayloadAction<ApiError>
{
    constructor(public readonly payload: ApiError) {
        super('Set Preferred Payment Info Request Failed');
    }

    reduce(state: SharedState): SharedState {
        return {
            ...state,
            ui: {
                ...state.ui,
                preferredPaymentInfo: {
                    loading: false
                }
            }
        };
    }
}

const typedReducer = createFeatureReducer(
    SharedActionReducer,
    initialSharedState
);

export function sharedReducer(state: any, action: any) {
    return typedReducer(state, action);
}
